import React, { useState } from 'react';
import { useHistory } from "react-router";
import PropTypes from 'prop-types';
import moment from 'moment';
import { makeStyles,withStyles ,createStyles} from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
  Avatar,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  Grid,
  Chip,
  FormGroup,
  FormControlLabel,
  Button,
  Radio,
  RadioGroup,
  FormControl
} from '@material-ui/core';
import CustomDialog from '../../../components/Notifications/Dialog';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { AdjustmentService, ChangeCommitteeService } from '../../../services';



//import { getInitials } from 'helpers';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    //minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  success:{
    backgroundColor:theme.palette.success.main
  }
}));

const ChangeCommitteeTable = props => {
  const { className, dataTable_Committee, onChangeOrderBy, onChangePage, onChangeTable,loader,length,onSelectRow, ...rest } = props;

  const history = useHistory();
  // const classes = useStyles();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('EmployeeCode');
  const [itemSelect,setItemSelect] = useState(null);
  const [isOpenViewFileComplete,setIsOpenViewFileComplete] = useState(false);

  const [isPrintAdjust,setIsPrintAdjust] = useState(false);
  const [isPrintReservedAdjust,setIsPrintReservedAdjust] = useState(false);
  const [hasPrintHeader,setHasPrintHeader] = useState(true);
  const [openLoading, setOpenLoading] = React.useState(false);

  const handleViewFile = (item) => {
    setIsPrintAdjust(false)
    setIsPrintReservedAdjust(false)
    setItemSelect(item);
    setIsOpenViewFileComplete(true)
  };

  

  const handlePageChange = (event, _page) => {
    setPage(_page);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event.target.value);
  };

  const handleRequestSort = (event, property) => {
    let dir = property!== orderBy?order: order==='asc'?'desc':'asc';
    setOrder(dir)
    setOrderBy(property)
    dataTable_Committee.sort(compareValues(property, dir))
  };

  const handleSelectRow = (property, obj) => {
    if(onSelectRow)
    {
      onSelectRow(property, obj);
    }
  };

  function compareValues(key, order = 'asc') {
    return function innerSort(a, b) {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        return 0;
      }
  
      const varA = (typeof a[key] === 'string')
        ? a[key].toUpperCase() : a[key];
      const varB = (typeof b[key] === 'string')
        ? b[key].toUpperCase() : b[key];
  
      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return (
        (order === 'desc') ? (comparison * -1) : comparison
      );
    };
  }

  const handlerEditClick = (index, runningId) => {
    
    history.push(`/ChangeCommittee/${runningId}`);
  };

  const toBoolean = (value) =>{
    if (value === 1)
        return true
    else if (value === true)
        return true
    else
        return false
  }

  function IsShowsLoading(props) {
    const { isLoading } = props;
    return (
        (isLoading ?
            <div id="loading-element">
                <div id="loading-indicator">
                    <div className="lds-ripple"><div></div><div></div></div>
                </div>
            </div>
            : null)
    )
}

  return (
    <Grid container>
      <Grid item xs={12}>
        <IsShowsLoading isLoading={openLoading} ></IsShowsLoading>
        <Table className="sp-table table rrs-table">
          <TableHead>
            <TableRow className="sp-table-header">
            <TableCell className="th-table text-center" style={{ width: '200px' }}>สถานะเอกสาร
                </TableCell>
              <TableCell className="th-table text-center" style={{ width: '50px' }}>PO/Contract No.
              </TableCell>
              <TableCell className="th-table text-center" >Header
                Text</TableCell>
              <TableCell className="th-table text-center" style={{ width: '200px' }}>Edit
                By</TableCell>
              <TableCell className="th-table text-center" style={{ width: '50px' }}>Edit
                Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              dataTable_Committee ? (
                dataTable_Committee.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((data, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className="text-center" onClick={() => handlerEditClick(index, data.running)} style={{ cursor: 'pointer' }} >{data.approve_status_name}</TableCell>
                        <TableCell className="text-center" onClick={() => handlerEditClick(index, data.running)} style={{ cursor: 'pointer' }}>{data.po_contract_no}</TableCell>
                        <TableCell className="text-left" onClick={() => handlerEditClick(index, data.running)} style={{ cursor: 'pointer' }}>{data.po_header_text}</TableCell>
                        <TableCell className="text-left" onClick={() => handlerEditClick(index, data.running)} style={{ cursor: 'pointer' }}>{data.requester_fullname}</TableCell>
                        <TableCell className="text-center" onClick={() => handlerEditClick(index, data.running)} style={{ cursor: 'pointer' }}>{data.action_date ? moment(data.action_date).format('DD/MM/YYYY') : ''}</TableCell>
                      </TableRow>
                    )
                  })) : (
                <TableRow key={0}>
                  <TableCell colSpan="11" className="text-center" style={{
                    textAlign: 'center',
                    fontStyle: 'italic',
                    color: 'gray',
                  }}>No data</TableCell>
                </TableRow>
              )
            }
          </TableBody>
        </Table>
      </Grid>
      <Grid item xs={12}>
        <TablePagination
          //component="div"
          count={dataTable_Committee ? dataTable_Committee.length : 0 }
          //onChangePage={handlePageChange}
          onPageChange={handlePageChange}
          //onChangeRowsPerPage={handleRowsPerPageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[2, 5, 10, 25]}
        />
      </Grid>
      
    </Grid>
  );
};

ChangeCommitteeTable.propTypes = {
  className: PropTypes.string,
  dataTable_Committee: PropTypes.array.isRequired
};

export default ChangeCommitteeTable;




